'use client';

import { CacheKeys, ServerActionName } from '@headless-workspace/config';
import { ResultServerActionType } from '@headless-workspace/core-domain';
import { TriggerWithArgs } from 'swr/mutation';
import { useSafeSWRMutation } from '../../../client';
import { updateWishlistServerAction, WishlistUpdateMode } from '../../../server';

type MutationTriggerReturnType = TriggerWithArgs<
    ResultServerActionType<boolean>,
    unknown,
    typeof CacheKeys.Wishlist,
    string
>;

type UseWishlistMutationsReturnType = {
    add: MutationTriggerReturnType;
    remove: MutationTriggerReturnType;
};

export const useWishlistMutations = (): UseWishlistMutationsReturnType => {
    const { trigger: additionTrigger } = useSafeSWRMutation<boolean, string>(
        CacheKeys.Wishlist,
        ServerActionName.updateWishlist,
        (_, { arg }) => updateWishlistServerAction(WishlistUpdateMode.Add, arg),
    );

    const { trigger: removalTrigger } = useSafeSWRMutation<boolean, string>(
        CacheKeys.Wishlist,
        ServerActionName.updateWishlist,
        (_, { arg }) => updateWishlistServerAction(WishlistUpdateMode.Delete, arg),
    );
    return {
        add: additionTrigger,
        remove: removalTrigger,
    };
};
